@if (fullscreenInitialized && !screenfull.isFullscreen && !disabled) {
  <div class="fullscreen-protection-layer">
    <button mat-fab class="primary-background" aria-label="Toggle fullscreen" (click)="toggleFullscreen()">
      <mat-icon>play_arrow</mat-icon>
    </button>
  </div>
}
